import moment from 'moment'
let time_format = v=>{
	if(v){
    return moment(v).format('MM-DD HH:mm')
  }else{
    return v
  }
}

export {time_format}


// WEBPACK FOOTER //
// ./src/utils/filters.js